module.exports = __webpack_public_path__ + "static/media/rv3.3e5f7a5c.jpg";